import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { BsArrowLeft } from 'react-icons/bs';
import styled from 'styled-components';

// selectors

// components
import SideNavContainer from '@components/common/nav/SideNavContainer';

// ActionCreators

// type
import { _getParameterByName } from '@utils/miscellaneous/urlSearchParams';
import HouseholdMembersTable from './HouseholdMembersTable';
import useHouseholdInfo from './useHouseholdInfo';
import EligibilityFactors from './EligibilityFactors';

//Const

import { configs } from '@constants/configs/configs';

import MedicaidChipMembersTable from './MedicaidChipTable';
import { ScreenType } from './types/apiResponse';

interface IHouseholds {
    householdSize?: number;
    householdIncome?: any;
    aptcEligibilityStartDate?: string;
    aptcEligibilityEndDate?: string;
    householdNumber?: number;
    aptcDetails?: {};
    members?: [Imembers];
}
interface Imembers {
    eligibilityFactors?: [];
}

const StyledMainContainer = styled.div`
    #main-content {
        padding: 1em 2em;
    }
`;

const StyledContainer = styled.div`
    border-radius: 5px;
    border: ${({ theme }) => `1px solid ${theme.gray8}`};
`;

const StyledEligibilityHeading = styled.div`
    justify-content: 'space-between';
`;

function ApplicationEligibility() {
    const encHouseHoldId = sessionStorage.getItem('encHouseHoldId');
    const { data, fetchApplicationEligibilityData } = useHouseholdInfo();
    //set member data
    const [memberData, setMemberData] = useState<[]>([]);
    const [households, sethouseholds] = useState<[IHouseholds]>();
    const [eligibilityFactors, seteligibilityFactors] = useState<[]>([]);
    const [selectedRow, setSelectedRow] = useState<number>(0);
    const [selectedRowIndex, setselectedRowIndex] = useState<number>(0);

    // setting initial data on load
    useEffect(() => {
        if (data?.houseHoldInfo?.households?.[0]?.members) {
            selectHousehold(0);
            setselectedRowIndex(0);
            handleShowEligibilityFactor(0);
            setSelectedRow(data?.houseHoldInfo.households?.[0]?.householdNumber);
            setMemberData(data?.houseHoldInfo.households?.[0]?.members || []);
        }
    }, [data]);

    useEffect(() => {
        let applicationObject = JSON.parse(localStorage.copySessionData.toString());
        fetchApplicationEligibilityData(applicationObject?.caseNumber);
    }, []);

    useEffect(() => {
        handleShowMember(selectedRowIndex);
    }, [selectedRowIndex, memberData]);

    const selectHousehold = selectedItem => {
        if (data?.houseHoldInfo?.households) {
            const selectedHouseHold = data?.houseHoldInfo?.households?.[selectedItem];
            const houseHolds = data?.houseHoldInfo?.households;
            houseHolds.forEach(elm => {
                delete elm?.isSelected;
            });
            if (selectedHouseHold) {
                Object.assign(selectedHouseHold, { isSelected: true });
            }
            houseHolds[selectedItem] = selectedHouseHold || [];
            sethouseholds(houseHolds);
        }
    };

    const selectedMemberId = (selectedItem: number) => {
        if (data?.houseHoldInfo?.households?.[selectedRowIndex]?.members) {
            const selectedMemeber = data?.houseHoldInfo?.households?.[selectedRowIndex]?.members?.[selectedItem];
            const members: any = data?.houseHoldInfo?.households?.[selectedRowIndex]?.members || [];
            members.forEach((elm: { isSelected }) => {
                delete elm?.isSelected;
            });
            if (selectedMemeber) {
                Object.assign(selectedMemeber, { isSelected: true });
            }
            members[selectedItem] = selectedMemeber || [];
            setMemberData(members);
        }
    };

    const handleShowMember = (index: any) => {
        selectHousehold(index);
        setselectedRowIndex(index);
        setSelectedRow(data?.houseHoldInfo.households?.[index]?.householdNumber);
        setMemberData(data?.houseHoldInfo.households?.[index]?.members);
        handleShowEligibilityFactor(0);
    };

    const handleShowEligibilityFactor = (index: any) => {
        selectedMemberId(index);
        seteligibilityFactors(
            data?.houseHoldInfo.households?.[selectedRowIndex]?.members?.[index]?.eligibilityFactors || [],
        );
    };

    return (
        <SideNavContainer>
            <StyledMainContainer className="desktop:grid-col-9 eligContent">
                <StyledContainer id="main-content">
                    <div className="back_to_application_from_eligibility">
                        <a href={`${configs.routes.MEMBER_APP_LIST}/${encHouseHoldId}`}>
                            <BsArrowLeft />
                            <FormattedMessage id="common.backToApplication" />
                        </a>
                    </div>
                    <div className="grid-col-12">
                        <StyledEligibilityHeading className="grid-row --header">
                            <h3>
                                <FormattedMessage id="application.eligibility.Details.heading" />
                            </h3>
                        </StyledEligibilityHeading>
                    </div>
                    <div>
                        <p>
                            <FormattedMessage id="application.eligibility.run.date" />{' '}
                            {data?.houseHoldInfo?.households?.[0]?.aptcEligibilityStartDate}
                            <br />
                            <FormattedMessage id="application.eligibility.evaulated_as_of" />{' '}
                            {data?.houseHoldInfo?.households?.[0]?.aptcEligibilityEndDate}
                        </p>
                    </div>
                    <div>
                        {data?.houseHoldInfo?.eligibilityDetails?.length > 0 && (
                            <>
                                <h4>
                                    <FormattedMessage id="application.eligibility.medicaid.chip" />
                                </h4>
                                <div className="eligibility_Chip_table ">
                                    <MedicaidChipMembersTable
                                        data={data?.houseHoldInfo?.eligibilityDetails || []}
                                        screenType={ScreenType.MedicaidMember}
                                        handleShowMember={handleShowEligibilityFactor}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                    <div>
                        <h4>
                            <FormattedMessage id="application.eligibility.tax.household" />
                        </h4>
                        <span>
                            <FormattedMessage id="application.eligibility.household.number" />
                            {`(${selectedRow})`}
                        </span>
                        <div className="eligibility_houshold_table">
                            <HouseholdMembersTable
                                data={households}
                                screenType={ScreenType.Household}
                                handleShowMember={handleShowMember}
                            />
                        </div>
                        <h4>
                            <FormattedMessage id="application.eligibility.household.members" />
                        </h4>
                        <div className="eligibility_Members_table">
                            <HouseholdMembersTable
                                data={memberData}
                                screenType={ScreenType.Member}
                                handleShowMember={handleShowEligibilityFactor}
                            />
                        </div>
                    </div>
                    <div className=""></div>
                    {eligibilityFactors.length > 0 && (
                        <>
                            <h4>
                                <FormattedMessage id="application.eligibility.factors" />
                            </h4>
                            <div className="eligibility_factors_container">
                                <ul>
                                    {eligibilityFactors.map((factors: string, index) => (
                                        <EligibilityFactors factors={factors} key={index}/>
                                    ))}
                                </ul>
                            </div>
                        </>
                    )}
                </StyledContainer>
            </StyledMainContainer>
        </SideNavContainer>
    );
}

export default ApplicationEligibility;
